export const scopeTypes = [
	'system',
	'country',
	'franchise',
	'organization',
	'principal',
	'customer',
	'client',
] as const;

export const scopeTypesSortedByHierarchy = [
	'system',
	'country',
	'franchise',
	'organization',
	'principal',
	'customer',
	'client',
] as const;
